import { useTooltipAnchor } from '@/hooks/useTooltipAnchor'

import { Box, Checkbox, Tooltip } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface RoleCheckboxOptionIProps {
  colorScheme: ColorScheme
  isChecked: boolean
  isRestricted: boolean
  label: string
  onChange: () => void
  restrictedLabel: string
  role: string
  testIdPrefix: string
}

/**
 * A single role checkbox for the Users & Access modals. A restricted role
 * (one the viewer may not grant) is disabled and shows a hint on hover.
 *
 * The disabled input fires no mouse events, so the wrapping `Box` carries the
 * hover handlers. Anchor state is per-instance (`useTooltipAnchor`), so each
 * option positions its own tooltip.
 */
export const RoleCheckboxOption = ({
  colorScheme,
  isChecked,
  isRestricted,
  label,
  onChange,
  restrictedLabel,
  role,
  testIdPrefix,
}: RoleCheckboxOptionIProps) => {
  const { anchorEl, onMouseEnter, onMouseLeave } = useTooltipAnchor()

  return (
    <>
      <Box
        data-testid={`${testIdPrefix}:roleOption:${role}`}
        onMouseEnter={isRestricted ? onMouseEnter : undefined}
        onMouseLeave={isRestricted ? onMouseLeave : undefined}
        w='fit-content'
      >
        <Checkbox
          checked={isChecked}
          colorScheme={colorScheme}
          data-testid={`${testIdPrefix}:role:${role}`}
          disabled={isRestricted}
          label={label}
          onChange={onChange}
        />
      </Box>
      <Tooltip
        anchorEl={anchorEl}
        colorScheme={colorScheme}
        label={restrictedLabel}
        placement='bottom'
      />
    </>
  )
}
